export default __webpack_public_path__ + "static/media/organization.628a3dd2.svg";